import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import { ConsentProvider } from "@/lib/consent";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import CityDealsPage from "@/pages/CityDealsPage";
import DealPage from "@/pages/DealPage";
import SubscribePage from "@/pages/SubscribePage";
import NewsletterActionPage from "@/pages/NewsletterActionPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPage from "@/pages/CookiesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PreferencesPage from "@/pages/PreferencesPage";

import GuidesIndexPage from "@/pages/guides/GuidesIndexPage";
import GuidePage from "@/pages/guides/GuidePage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminTOTPSetup from "@/pages/admin/AdminTOTPSetup";
import AdminShell from "@/pages/admin/AdminShell";
import AdminDealsList from "@/pages/admin/AdminDealsList";
import AdminDealForm from "@/pages/admin/AdminDealForm";
import AdminSubscribersPage from "@/pages/admin/AdminSubscribersPage";
import AdminDealFinder from "@/pages/admin/AdminDealFinder";
import AdminGuidesList from "@/pages/admin/AdminGuidesList";
import AdminGuideEdit from "@/pages/admin/AdminGuideEdit";

import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <ConsentProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/from/:city" element={<CityDealsPage />} />
              <Route path="/deal/*" element={<DealPage />} />
              <Route path="/subscribe" element={<SubscribePage />} />
              <Route path="/newsletter/confirm" element={<NewsletterActionPage mode="confirm" />} />
              <Route path="/newsletter/unsubscribe" element={<NewsletterActionPage mode="unsubscribe" />} />
              <Route path="/preferences" element={<PreferencesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/guides" element={<GuidesIndexPage />} />
              <Route path="/guides/:slug" element={<GuidePage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiesPage />} />

              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/totp-setup" element={<AdminTOTPSetup />} />
              <Route path="/admin" element={<AdminShell />}>
                <Route index element={<AdminDealsList />} />
                <Route path="new" element={<AdminDealForm />} />
                <Route path="edit/:id" element={<AdminDealForm />} />
                <Route path="subscribers" element={<AdminSubscribersPage />} />
                <Route path="deal-finder" element={<AdminDealFinder />} />
                <Route path="guides" element={<AdminGuidesList />} />
                <Route path="guides/:slug" element={<AdminGuideEdit />} />
              </Route>
            </Routes>
            <Toaster position="top-center" richColors />
            <CookieBanner />
          </div>
        </BrowserRouter>
      </AuthProvider>
      </ConsentProvider>
    </HelmetProvider>
  );
}

export default App;
